module.exports = __webpack_public_path__ + "img/message.5952a2c6.svg";